import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';

import { ComponentsModule } from '../components.module';
import { ReplacementPartsPage } from './replacement-parts';

@NgModule({
  declarations: [
    ReplacementPartsPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(ReplacementPartsPage),
  ],
  exports: [
    ReplacementPartsPage
  ]
})
export class ReplacementPartsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/replacement-parts/replacement-parts.module.ts